module.exports = __webpack_public_path__ + "static/media/icon_deflector.b045c291.svg";